import { captureSlowWarning } from 'src/app/project/modules/errors/response-error';
import { TSlowModalOpenReport } from './utils/build-slow-modal-open-report';

export const SLOW_MODAL_OPEN_TIMEOUT_MS = 5000;

const SLOW_OPEN_MESSAGE = 'Point modal did not open within the expected time';
const SLOW_OPEN_TAG = 'slow_modal_open';

let pendingTimer: ReturnType<typeof setTimeout> | null = null;

export const clearPointModalOpenTimer = (): void => {
  if (pendingTimer === null) {
    return;
  }

  clearTimeout(pendingTimer);
  pendingTimer = null;
};

const reportSlowModalOpen = (report: TSlowModalOpenReport): void => {
  captureSlowWarning({
    message: SLOW_OPEN_MESSAGE,
    tag: SLOW_OPEN_TAG,
    view: report.view,
    workspaceId: report.workspaceId,
    extra: {
      url: report.url,
      pointId: report.pointId,
      userEmail: report.userEmail,
      userId: report.userId,
      accountId: report.accountId,
      timeoutMs: SLOW_MODAL_OPEN_TIMEOUT_MS,
    },
  });
};

export const startPointModalOpenTimer = (buildReport: () => TSlowModalOpenReport): void => {
  clearPointModalOpenTimer();

  pendingTimer = setTimeout(() => {
    pendingTimer = null;
    reportSlowModalOpen(buildReport());
  }, SLOW_MODAL_OPEN_TIMEOUT_MS);
};
